import { render, staticRenderFns } from "./NewSqaComponent.vue?vue&type=template&id=52f534d2&scoped=true"
import script from "./NewSqaComponent.vue?vue&type=script&lang=js"
export * from "./NewSqaComponent.vue?vue&type=script&lang=js"
import style0 from "./NewSqaComponent.vue?vue&type=style&index=0&id=52f534d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f534d2",
  null
  
)

export default component.exports